import { useRecoilState } from 'recoil';
import projectAtom from 'ProjectManager/Project/Common/recoil/project/projectAtom';
import { useCallback, useEffect, useMemo } from 'react';
import axios from 'axios';
import uploadGeneralProjectFiles from 'ProjectManager/Project/Common/api/dataManagement/generalFile/uploadGeneralProjectFiles';
import getGeneralProjectFiles from 'ProjectManager/Project/Common/api/dataManagement/generalFile/getGeneralProjectFiles';
import withGeneralFiles from 'ProjectManager/DataManagement/Common/recoil/projectOrTemplate/modifiers/generalFile/withGeneralFiles';

const useUploadProjectFilesFunction = () => {
    const [{ id: projectId }, setProject] = useRecoilState(projectAtom);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    // noinspection UnnecessaryLocalVariableJS
    const uploadFiles = useCallback(
        async acceptedFiles => {
            await uploadGeneralProjectFiles(
                projectId,
                acceptedFiles,
                source.token,
            );

            const response = await getGeneralProjectFiles(
                projectId,
                source.token,
            );

            setProject(withGeneralFiles(response.data));
        },
        [projectId, setProject, source.token],
    );

    return uploadFiles;
};

export default useUploadProjectFilesFunction;
